import { render, staticRenderFns } from "./InputFileGroup.vue?vue&type=template&id=012ee250"
import script from "./InputFileGroup.vue?vue&type=script&lang=js"
export * from "./InputFileGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports